import { global_logo_grid } from '../../utils/requests/contentstack/contentStackZodSchema';
import { type LogoGridProps } from './LogoGrid';
import { getCloudinaryImageFields } from '../../utils/getCloudinaryItem/getCloudinaryItem';
export const logoGridSchema = global_logo_grid.transform<LogoGridProps>(data => {
  return {
    logoHeader: {
      title: data.header.title,
      description: data.header.description,
      descriptionLinks: data.header.description_links.map(descriptionLink => {
        return {
          href: descriptionLink.href,
          text: descriptionLink.title
        };
      })
    },
    logos: data.logos.map<LogoGridProps['logos'][number]>(logo => {
      return getCloudinaryImageFields({
        alt: logo.alt_text,
        cloudinaryField: logo.src,
        shouldUseV2: true
      });
    }),
    columnCount: data.column_count
  };
});